import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import MainLayout from '../../components/Layout/MainLayout';
import {
  Save,
  ArrowLeft,
  Info,
  List,
  Image as ImageIcon,
  Layout,
  Layers,
  Plus,
  Trash2,
  X,
  Upload,
  Check,
  Package,
  Activity,
  ChevronRight,
  FileText,
  DollarSign,
  Tag,
  Maximize2
} from 'lucide-react';
import './ProductEditor.css';
import { handleGetApi, handlePostApi } from '../../api/api';
import Cookies from 'js-cookie';

const ProductEditor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  const token = JSON.parse(Cookies.get('auth_token'));
  const headers = {
    Authorization: token
  }
  // const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const fetchSingleProduct = async () => {
  try {
    const res = await handleGetApi(
      `admin/get/product/${id}`,
      headers
    );
console.log(res,'res')
    setFormData(res.data);

  } catch (error) {
    console.log(error);
  }
};
  const fetchCategory = async () => {
    const res = await handleGetApi('admin/get/category', headers)
    setCategories(res.data)
  }
  // const fetchSubCategory = async () => {
  //   const res = await handleGetApi('admin/get/subCategory', headers)
  //   setSubCategories(res.data)
  // }
  useEffect(() => {
    fetchCategory();
    // fetchSubCategory();
    if (isEdit) {
    fetchSingleProduct();
  }
  }, [id]);
  const [activeTab, setActiveTab] = useState('basic');
  const [formData, setFormData] = useState({
    // Basic Info
    name: '',
    slug: '',
    category_id: '',
    // subcategory_id: '',
    shortDescription: '',
    description: '',
    badge: '',
    rating: '',
    reviewCount: 0,
    status: 'Active',
    featured: false,
    is_new_arrival: false,

    // Specifications
    specifications: [{ spec_title: '', spec_value: '' }],

    // Sections
    sections: [{ section_name: '', section_content: '' }],

    // Variants
    variants: [
      {
        id: Date.now(),
        variantName: '',
        sku: '',
        mrp: '',
        price: '',
        stock: '',
        weight: '',
        height: '',
        proLength: '',
        breadth: '',
        status: 'Active',
        thumbnail: '',
        attributes: [{ attribute_name: '', attribute_value: '' }],
        images: []
      }
    ]
  });
  console.log(formData, 'formData')
  // Handle Input Changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Specification Handlers
  const addSpec = () => setFormData(prev => ({ ...prev, specifications: [...prev.specifications, { spec_title: '', spec_value: '' }] }));
  const removeSpec = (index) => setFormData(prev => ({ ...prev, specifications: prev.specifications.filter((_, i) => i !== index) }));
  const updateSpec = (index, field, value) => {
    const newSpecs = [...formData.specifications];
    newSpecs[index][field] = value;
    setFormData(prev => ({ ...prev, specifications: newSpecs }));
  };

  // Section Handlers
  const addSection = () => setFormData(prev => ({ ...prev, sections: [...prev.sections, { section_name: '', section_content: '' }] }));
  const removeSection = (index) => setFormData(prev => ({ ...prev, sections: prev.sections.filter((_, i) => i !== index) }));
  const updateSection = (index, field, value) => {
    const newSections = [...formData.sections];
    newSections[index][field] = value;
    setFormData(prev => ({ ...prev, sections: newSections }));
  };

  // Variant Handlers
  const addVariant = () => setFormData(prev => ({
    ...prev,
    variants: [...prev.variants, {
      id: Date.now(),
      variantName: '',
      sku: '',
      mrp: '',
      price: '',
      stock: '',
      weight: '',
      height: '',
        proLength: '',
        breadth: '',
      status: 'Active',
      thumbnail: '',
      attributes: [{ attribute_name: '', attribute_value: '' }],
      images: []
    }]
  }));
  const removeVariant = (index) => setFormData(prev => ({ ...prev, variants: prev.variants.filter((_, i) => i !== index) }));
  const updateVariant = (vIndex, field, value) => {
    const newVariants = [...formData.variants];
    newVariants[vIndex][field] = value;
    setFormData(prev => ({ ...prev, variants: newVariants }));
  };

  const updateVariantAttribute = (vIndex, aIndex, field, value) => {
    const newVariants = [...formData.variants];
    newVariants[vIndex].attributes[aIndex][field] = value;
    setFormData(prev => ({ ...prev, variants: newVariants }));
  };
  const addVariantAttribute = (vIndex) => {
    const newVariants = [...formData.variants];
    newVariants[vIndex].attributes.push({ attribute_name: '', attribute_value: '' });
    setFormData(prev => ({ ...prev, variants: newVariants }));
  };
  const removeVariantAttribute = (vIndex, aIndex) => {
    const newVariants = [...formData.variants];
    newVariants[vIndex].attributes.splice(aIndex, 1);
    setFormData(prev => ({ ...prev, variants: newVariants }));
  };

  const handleVariantThumbnail = (
  vIndex,
  e
) => {

  const file = e.target.files[0];

  if (!file) return;

  const newVariants = [
    ...formData.variants
  ];

  newVariants[vIndex].thumbnail =
    file;

  setFormData((prev) => ({

    ...prev,

    variants: newVariants,

  }));

};


const removeVariantThumbnail = (
  vIndex
) => {

  const newVariants = [
    ...formData.variants
  ];

  newVariants[vIndex].thumbnail =
    null;

  setFormData((prev) => ({

    ...prev,

    variants: newVariants,

  }));

};

const handleVariantImageUpload = (
  vIndex,
  e
) => {

  const files = Array.from(
    e.target.files
  );

  if (files.length === 0) return;

  const newVariants = [
    ...formData.variants
  ];

  newVariants[vIndex].images = [

    ...newVariants[vIndex].images,

    ...files,
    ];

  setFormData((prev) => ({

    ...prev,

    variants: newVariants,

  }));

};

  const removeVariantImage = (
  vIndex,
  iIndex
) => {

  const newVariants = [
    ...formData.variants
  ];

  newVariants[vIndex]
    .images.splice(iIndex, 1);

  setFormData((prev) => ({

    ...prev,

    variants: newVariants,

  }));

};

  const handleSave = async (e) => {

  e.preventDefault();
  if(formData?.variants?.length < 1){
    alert("Please add minimum 1 variant")
    return
  }
  try {

    const submitData = new FormData();
    // ======================
    // VARIANT FILES
    // ======================

    formData.variants.forEach(
      (variant, index) => {

        // Variant Thumbnail

        if (
          variant.thumbnail &&
          typeof variant.thumbnail !== "string"
        ) {

          submitData.append(
            `variant_thumbnail_${index}`,
            variant.thumbnail
          );

        }

        // Variant Images

        variant.images.forEach((img) => {

          if (typeof img !== "string") {

            submitData.append(
              `variant_images_${index}`,
              img
            );

          }

        });

      }
    );

    // ======================
    // JSON DATA
    // ======================

    submitData.append(
      "data",
      JSON.stringify({
        ...formData,
        id
      })
    );

    const res = await handlePostApi(
      "admin/update/product",
      submitData,
      headers
    );

    alert(res.message);

    navigate("/products");

  } catch (error) {

    console.log(error);

  }

};

  const tabs = [
    { id: 'basic', label: 'Basic Info', icon: <Info size={18} /> },
    { id: 'specs', label: 'Specifications', icon: <List size={18} /> },
    { id: 'sections', label: 'Sections', icon: <Layout size={18} /> },
    { id: 'variants', label: 'Variants', icon: <Layers size={18} /> },
  ];

  return (
    <MainLayout title='Edit Product'>
      <div className="product-editor-container fade-in">
        <div className="editor-header">
          <button className="back-btn" onClick={() => navigate('/products')}>
            <ArrowLeft size={20} />
            <span>Back to Products</span>
          </button>
          <div className="header-actions">
            <button className="save-product-btn" onClick={handleSave}>
              <Save size={20} />
              <span>Update Changes</span>
            </button>
          </div>
        </div>

        <div className="editor-layout">
          <aside className="editor-sidebar">
            <nav className="editor-tabs">
              {tabs.map(tab => (
                <button
                  key={tab.id}
                  className={`tab-item ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <span className="tab-icon">{tab.icon}</span>
                  <span className="tab-label">{tab.label}</span>
                  {activeTab === tab.id && <ChevronRight size={16} style={{ marginLeft: 'auto' }} />}
                </button>
              ))}
            </nav>
          </aside>

          <main className="editor-content-area">
            <div className="tab-panel">
              {activeTab === 'basic' && (
                <div className="panel-content">
                  <div className="section-title"><FileText size={20} /> General Information</div>
                  <div className="basic-info-grid">
                    <div className="form-group full-width">
                      <label>Product Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="e.g. Modern Velvet Sofa"
                      />
                    </div>
                    <div className="form-group">
                      <label>Slug (URL Key)</label>
                      <input
                        type="text"
                        name="slug"
                        value={formData.slug}
                        onChange={handleInputChange}
                        placeholder="e.g. modern-velvet-sofa"
                      />
                    </div>
                    <div className="form-group">
                      <label>Badge (e.g. New, Bestseller)</label>
                      <input
                        type="text"
                        name="badge"
                        value={formData.badge}
                        onChange={handleInputChange}
                        placeholder="Optional"
                      />
                    </div>
                    <div className="form-group">
                      <label>Category</label>
                      <select name="category_id" value={formData.category_id} onChange={handleInputChange}>
                        <option value="">Select Category</option>
                        {categories?.map((cat) => {
                          return (
                            <option value={cat?.id}>{cat?.name}</option>
                          )
                        })}

                      </select>
                    </div>
                    {/* <div className="form-group">
                      <label>Sub Category</label>
                      <select name="subcategory_id" value={formData.subcategory_id} onChange={handleInputChange}>
                        <option value="">Select Sub Category</option>
                        {subCategories?.map((cat) => {
                          return (
                            <option value={cat?.id}>{cat?.name}</option>
                          )
                        })}
                      </select>
                    </div> */}
                  </div>

                  <div className="section-title"><Tag size={20} /> Descriptions</div>
                  <div className="panel-content" style={{ gap: '20px' }}>
                    <div className="form-group">
                      <label>Short Description</label>
                      <input
                        type="text"
                        name="shortDescription"
                        value={formData.shortDescription}
                        onChange={handleInputChange}
                        placeholder="A brief summary..."
                      />
                    </div>
                    <div className="form-group">
                      <label>Long Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        rows={6}
                        placeholder="Detailed product details..."
                      />
                    </div>
                  </div>

                  <div className="section-title"><Activity size={20} /> Extras</div>
                  <div className="basic-info-grid">
                    <div className="form-group">
                      <label>Average Rating</label>
                      <input
                        type="number"
                        step="0.1"
                        name="rating"
                        value={formData.rating}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label>Review Count</label>
                      <input
                        type="number"
                        name="reviewCount"
                        value={formData.reviewCount}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="featured"
                          checked={formData.featured}
                          onChange={handleInputChange}
                        />
                        <span>Feature this product on homepage</span>
                      </label>
                    </div>
                     <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="is_new_arrival"
                          checked={formData.is_new_arrival}
                          onChange={handleInputChange}
                        />
                        <span>New Arrival this product on homepage</span>
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'specs' && (
                <div className="panel-content">
                  <div className="content-header">
                    <div className="section-title"><List size={20} /> Product Specifications</div>
                    <button className="add-btn-small" onClick={addSpec}>
                      <Plus size={16} /> Add Specification
                    </button>
                  </div>
                  <div className="specs-editor">
                    {formData.specifications.map((spec, index) => (
                      <div key={index} className="spec-row">
                        <input
                          placeholder="Label (e.g. Material)"
                          value={spec.spec_title}
                          onChange={(e) => updateSpec(index, 'spec_title', e.target.value)}
                        />
                        <input
                          placeholder="Value (e.g. Solid Oak)"
                          value={spec.spec_value}
                          onChange={(e) => updateSpec(index, 'spec_value', e.target.value)}
                        />
                        <button className="delete-btn-icon" onClick={() => removeSpec(index)}>
                          <Trash2 size={20} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* {activeTab === 'images' && (
                <div className="panel-content">
                  <div className="section-title"><ImageIcon size={20} /> Product Gallery</div>
                  <div className="image-upload-grid">
                    <div className="upload-card">
                      <div className="form-group">
                        <label>Main Thumbnail</label>
                        <div className="preview-box">
                          {formData.thumbnail ? <img src={formData.thumbnail} alt="Thumb" /> : <Upload size={40} />}
                        </div>
                        <button className="upload-trigger-btn">Select Image</button>
                      </div>
                    </div>
                    <div className="upload-card">
                      <div className="form-group">
                        <label>Gallery Images</label>
                        <div className="gallery-previews">
                          {formData.gallery.map((img, idx) => (
                            <div key={idx} className="gallery-item">
                              <img src={img} alt="Gallery" />
                              <button className="remove-gallery-img" onClick={() => {
                                const newGal = [...formData.gallery];
                                newGal.splice(idx, 1);
                                setFormData({ ...formData, gallery: newGal });
                              }}><X size={14} /></button>
                            </div>
                          ))}
                          <button className="add-gallery-btn"><Plus size={24} /></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}

              {activeTab === 'sections' && (
                <div className="panel-content">
                  <div className="content-header">
                    <div className="section-title"><Layout size={20} /> Product Page Sections</div>
                    <button className="add-btn-small" onClick={addSection}>
                      <Plus size={16} /> Add New Section
                    </button>
                  </div>
                  <div className="sections-list">
                    {formData.sections.map((section, index) => (
                      <div key={index} className="section-card">
                        <div className="section-card-header">
                          <input
                            placeholder="Section Title"
                            value={section.section_name}
                            onChange={(e) => updateSection(index, 'section_name', e.target.value)}
                          />
                          <button className="delete-btn-icon" onClick={() => removeSection(index)}>
                            <Trash2 size={20} />
                          </button>
                        </div>
                        <textarea
                          placeholder="Detailed content for this section..."
                          value={section.section_content}
                          onChange={(e) => updateSection(index, 'section_content', e.target.value)}
                          rows={4}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {activeTab === 'variants' && (
                <div className="panel-content">
                  <div className="content-header">
                    <div className="section-title"><Layers size={20} /> Product Variants</div>
                    <button className="add-btn-small" onClick={addVariant}>
                      <Plus size={16} /> Add New Variant
                    </button>
                  </div>
                  <div className="variants-list">
                    {formData.variants.map((variant, vIdx) => (
                      <div key={vIdx} className="variant-card">
                        <div className="variant-card-header">
                          <div className="variant-id-badge">Variant ID: #{vIdx + 1}</div>
                          <button className="delete-btn-icon" onClick={() => removeVariant(vIdx)}>
                            <Trash2 size={20} />
                          </button>
                        </div>

                        <div className="variant-grid">
                          <div className="variant-main-info">
                            <div className="section-subtitle"><Tag size={16} /> Core Identification</div>
                            <div className="form-row-triple">
                              <div className="form-group">
                                <label>Variant Display Name</label>
                                <input
                                  placeholder="e.g. Royal Blue / Large"
                                  value={variant.variantName}
                                  onChange={(e) => updateVariant(vIdx, 'variantName', e.target.value)}
                                />
                              </div>
                              <div className="form-group">
                                <label>SKU</label>
                                <input
                                  placeholder="SKU-001"
                                  value={variant.sku}
                                  onChange={(e) => updateVariant(vIdx, 'sku', e.target.value)}
                                />
                              </div>
                              <div className="form-group">
                                <label>Status</label>
                                <select
                                  value={variant.status}
                                  onChange={(e) => updateVariant(vIdx, 'status', e.target.value)}
                                >
                                  <option value="Active">Active</option>
                                  <option value="Inactive">Inactive</option>
                                </select>
                              </div>
                            </div>

                            <div className="section-subtitle"><DollarSign size={16} /> Logistics & Pricing</div>
                            <div className="form-row-quad">
                              <div className="form-group">
                                <label>MRP</label>
                                <input
                                  type="number"
                                  placeholder="0.00"
                                  value={variant.mrp}
                                  onChange={(e) => updateVariant(vIdx, 'mrp', e.target.value)}
                                />
                              </div>
                              <div className="form-group">
                                <label>Price</label>
                                <input
                                  type="number"
                                  placeholder="0.00"
                                  value={variant.price}
                                  onChange={(e) => updateVariant(vIdx, 'price', e.target.value)}
                                />
                              </div>
                              <div className="form-group">
                                <label>Stock</label>
                                <input
                                  type="number"
                                  placeholder="0"
                                  value={variant.stock}
                                  onChange={(e) => updateVariant(vIdx, 'stock', e.target.value)}
                                />
                              </div>
                              <div className="form-group">
                                <label>Weight (kg)</label>
                                <input
                                  type="number"
                                  placeholder="0.0"
                                  value={variant.weight}
                                  onChange={(e) => updateVariant(vIdx, 'weight', e.target.value)}
                                />
                              </div>
                              <div className="form-group">
                                <label>Height (CM)</label>
                                <input
                                  type="number"
                                  placeholder="0.0"
                                  value={variant.height}
                                  onChange={(e) => updateVariant(vIdx, 'height', e.target.value)}
                                />
                              </div>
                              <div className="form-group">
                                <label>Length (CM)</label>
                                <input
                                  type="number"
                                  placeholder="0.0"
                                  value={variant.proLength}
                                  onChange={(e) => updateVariant(vIdx, 'proLength', e.target.value)}
                                />
                              </div>
                              <div className="form-group">
                                <label>Breadth (CM)</label>
                                <input
                                  type="number"
                                  placeholder="0.0"
                                  value={variant.breadth}
                                  onChange={(e) => updateVariant(vIdx, 'breadth', e.target.value)}
                                />
                              </div>
                            </div>

                            <div className="variant-attributes-section">
                              <div className="section-subtitle"><Package size={16} /> Production Attributes</div>
                              <div className="attributes-container">
                                {variant.attributes.map((attr, aIdx) => (
                                  <div key={aIdx} className="attr-production-row">
                                    <div className="attr-field">
                                      <input
                                        placeholder="Attribute (e.g. Color)"
                                        value={attr.attribute_name}
                                        onChange={(e) => updateVariantAttribute(vIdx, aIdx, 'attribute_name', e.target.value)}
                                      />
                                    </div>
                                    <div className="attr-field">
                                      <input
                                        placeholder="Value (e.g. Royal Blue)"
                                        value={attr.attribute_value}
                                        onChange={(e) => updateVariantAttribute(vIdx, aIdx, 'attribute_value', e.target.value)}
                                      />
                                    </div>
                                    <button className="remove-attr-small" onClick={() => removeVariantAttribute(vIdx, aIdx)}>
                                      <X size={14} />
                                    </button>
                                  </div>
                                ))}
                              </div>
                              <button className="add-attr-btn-production" onClick={() => addVariantAttribute(vIdx)}>
                                <Plus size={16} /> Add Production Attribute
                              </button>
                            </div>
                          </div>

                          <div className="variant-media-info">
                            <div className="section-subtitle"><ImageIcon size={16} /> Variant Media</div>
                            <div className="form-group">
                              <label>Primary Thumbnail</label>
                              <div className="var-thumb-box-v2">
                                {variant.thumbnail ? (
                                  <div className="thumb-preview">
                                    <img
  src={
    typeof variant.thumbnail === "string"
      ? `${process.env.REACT_APP_IMAGE_URL}variants/${variant.thumbnail}`
      : URL.createObjectURL(
          variant.thumbnail
        )
  }
  alt=""
/>
                                    <button
  className="clear-thumb"
  onClick={() =>
    removeVariantThumbnail(vIdx)
  }
>
  <X size={14} />
</button>
                                  </div>
                                ) : (
                                  <div className="upload-placeholder">

  <input
    type="file"
    hidden
    id={`variant-thumb-${vIdx}`}
    accept="image/*"
    onChange={(e) =>
      handleVariantThumbnail(
        vIdx,
        e
      )
    }
  />

  <label
    htmlFor={`variant-thumb-${vIdx}`}
  >
    <Upload size={24} />
    <span>Upload</span>
  </label>

</div>
                                )}
                              </div>
                            </div>
                            <div className="form-group">
                              <label>Variant Gallery ({variant.images.length})</label>
                              <div className="var-gallery-grid-v2">
                                {variant.images.map((img, iIdx) => (
                                  <div key={iIdx} className="var-gallery-item-v2">
                                    <img
  src={
    typeof img === "string"
      ? `${process.env.REACT_APP_IMAGE_URL}variants/${img}`
      : URL.createObjectURL(img)
  }
  alt=""
/>
                                    <button className="remove-v-img" onClick={() => removeVariantImage(vIdx, iIdx)}>
                                      <X size={12} />
                                    </button>
                                  </div>
                                ))}
                                <label className="add-v-img-label">
                                  <Plus size={20} />
                                  <input
                                    type="file"
                                    multiple
                                    style={{ display: 'none' }}
                                    onChange={(e) => handleVariantImageUpload(vIdx, e)}
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </main>
        </div>
      </div>
    </MainLayout>
  );
};

export default ProductEditor;
